import {useBannersContext} from '../infrastructure/BannersContext';
import {RemoteDataUI} from '../../../common/ui/RemoteDataUI';
import {Spinner} from 'react-bootstrap';
import styled from 'styled-components';
import React from 'react';

const CatalogLink = styled.a`
    display: block;
    width: 100%;
    max-width: 450px;
`;

const CatalogImage = styled.img`
    width: 100%;
    max-width: 450px;
    aspect-ratio: 9 / 2;
    height: auto;
    object-fit: cover;
    border-radius: 15px;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
    cursor: pointer;

    transition:
            transform 0.25s ease,
            box-shadow 0.25s ease,
            filter 0.25s ease;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            transform: scale(1.03);
            box-shadow: 8px 10px 25px rgba(0, 0, 0, 0.3);
            filter: brightness(1.05);
        }
    }

    @media (max-width: 576px) {
        border-radius: 12px;
    }
`;


export const Catalogs = () => {
    const { catalogsRemoteData } = useBannersContext();

    return (
        <RemoteDataUI remoteData={catalogsRemoteData}>
            <RemoteDataUI.Pending>
                <div className="text-center"><Spinner /></div>
            </RemoteDataUI.Pending>

            <RemoteDataUI.Success>
                {catalogs => catalogs.length === 0 ? null : (
                    <section className="d-flex flex-column gap-4 align-items-center">
                        <div className="d-flex flex-column flex-md-row gap-4 align-items-center justify-content-center w-100">
                            {catalogs.map((catalog, index) => (
                                <CatalogLink key={index} href={catalog.link} target="_blank" rel="noopener noreferrer">
                                    <CatalogImage src={catalog.imageUrl} alt={catalog.title} />
                                </CatalogLink>
                            ))}
                        </div>
                    </section>
                )}
            </RemoteDataUI.Success>
        </RemoteDataUI>
    );
};
